<template>
  <div
    id="tree-tabulator"
    ref="tableRef"
    class="table-report table-report--tabulator"
    :data-test="`${tableName}-data-table`"
  />
</template>

<script>
import { defineComponent, ref, reactive, onMounted } from 'vue'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
// import axios from "axios";
import { useRoute, useRouter } from 'vue-router'
import { useStore } from "vuex";


export default defineComponent({
  props: {
    dataArrayTable: {
      type: Array,
    },
    paginationSize: {
      type: Number,
      default: 10,
    },
    paginationSizeArray: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
    dataArray: {
      type: Array,
    },
    apiUrl: {
      type: String,
    },
    tableName: {
      type: String,
      default: "init"
    },
    routerName:{
      type: String
    },
    apiParams:{
      type: Object
    },
    totalList:{
      type: Number
    },
    methodRequest:{
      type: String
    }
  },
  setup(props) {
    const tableRef = ref();
    const tabulator = ref();
    // console.log("props ", props.dataArrayTable);
    const router = useRouter()
    const route = useRoute()
    // const store = useStore();
    // const token = store.getters["userAuth/getToken"];
    const initTabulator = () => {
      tabulator.value = new Tabulator(tableRef.value, {
        locale: "th-th",
        langs: {
          "th-th": {
            pagination: {
              page_size: "แสดง",
            },
          },
        },
        data: props.dataArray,
        // ajaxURL: `${process.env.VUE_APP_BASE_API}${props.apiUrl}`, //call api if using api no need to send dataArray
        // ajaxConfig: props.methodRequest,
        // ajaxParams: props.apiParams,
        // ajaxContentType:{
        //   headers:{
        //     Authorization: `Bearer ${token}`,
        //     'Content-Type': 'application/json',
        //   },
        //   body:function(url, config, params){
        //     params.length = String(params.length)
        //     params.start = String(params.start)
        //     return JSON.stringify(params)
        //   },
        // },
        // ajaxResponse:function(url, params, response){
        //   document.querySelector(".totalList").innerHTML = response.recordsTotal
        //   return response; //return the tableData property of a response json object
        // },
        /*rowSelectionChanged:function(data, rows){
            //update selected row counter on selection change
          console.log("daa ", data);
          console.log("r ", rows);
        },*/
        rowClick: function(e, row){
          if(props.routerName == "household"){
            router.push({
              name: 'household-profile',
              params:{
                hhid: row._row.data._id
              }
            })
          }
          else if(props.routerName == "family"){
            router.push({
              name: 'family-profile',
              params:{
                // hhid: row._row.data.hh_id,
                famid: row._row.data._id
              }
            })
          }
          else if(props.routerName == "member"){
            router.push({
              name: 'member-profile',
              params:{
                // hhid: route.params.hhid,
                // famid: route.params.famid,
                mid: row._row.data._id
              }
            })
          }
        },
        pageLoaded: function(e, row){
          if(window.innerWidth > 1005){
            document.querySelectorAll(".tabulator-col").forEach((col)=>{
              if(col.style.display == 'none'){
                col.style.display = 'inline-block'
                col.setAttribute("hide","true")
              }
              //check cell field name equal to header column and set width
              document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
                if(cell.getAttribute('tabulator-field') == col.getAttribute('tabulator-field')){
                  cell.style.width = cell.style.width ? cell.style.width : cell.style.minWidth
                }
              })
            })
            document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
              if(cell.style.display == 'none')
                cell.style.display = 'inline-block'
            })
          }
        },
        // layout:"fitColumns",
        // responsiveLayout:'collapse',
        pagination: 'local',
        headerSort:true,
        paginationSize: props.paginationSize,
        paginationSizeSelector: props.paginationSizeArray,
        cellVertAlign:"middle",
        placeholder:"ไม่มีข้อมูล",
        footerElement:`<span class="mb-1">ทั้งหมด <span class="totalList">${props.dataArray.length}</span> รายการ</span>`,
        columns: props.dataArrayTable,
        columnHeaderSortMulti:true,
        dataTree:true,
        dataTreeStartExpanded:false,
        columnHeaderVertAlign:"bottom",
        renderComplete() {
          feather.replace({
            'stroke-width': 2
          })
        }
      })
    }
    const testSort = () =>{
      let ee = tabulator.value.getSorters()
    }
    // Redraw table onresize
    const reInitOnResizeWindow = () => {
      //when load
      /* if(window.innerWidth > 1005){
        document.querySelectorAll(".tabulator-col").forEach((col)=>{
          if(col.style.display == 'none'){
            col.style.display = 'inline-block'
            col.setAttribute("hide","true")
          }
          //check cell field name equal to header column and set width
          document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
            if(cell.getAttribute('tabulator-field') == col.getAttribute('tabulator-field')){
              cell.style.width = cell.style.width ? cell.style.width : cell.style.minWidth
            }
          })
        })
        document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
          if(cell.style.display == 'none')
            cell.style.display = 'inline-block'
        })
      } */

      window.addEventListener("resize", () => {
        tabulator.value.redraw();
        /* if(window.innerWidth <= 1005){
          document.querySelectorAll(".tabulator-col").forEach((col)=>{
            if(col.hasAttribute('hide')){
              document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
                if(col.style.display == 'inline-block' && (cell.getAttribute('tabulator-field') == col.getAttribute('tabulator-field'))){
                  cell.style.display = 'none'
                  cell.style.removeProperty('height')
                }
              })
            }
            else{//when resize from small to large screen
              document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
                if(col.style.display == 'none' && (cell.getAttribute('tabulator-field') == col.getAttribute('tabulator-field'))){
                  cell.style.display = 'none'
                  cell.style.removeProperty('height')
                }
              })
            }
           })
        }
        else{
          // always display every column
          document.querySelectorAll(".tabulator-col").forEach((col)=>{
            if(col.style.display == 'none'){
              col.style.display = 'inline-block'
              col.setAttribute("hide","true")
            }
          })
          document.querySelectorAll(".tabulator-cell").forEach((cell)=>{
              cell.style.display = 'inline-block'
              cell.style.removeProperty('height')
          })
        } */
        feather.replace({
          "stroke-width": 1.5,
        });
      });
    };

    onMounted(() => {
      initTabulator()
      reInitOnResizeWindow()
    })

    return {
      tableRef,
      testSort
    }
  }
})
</script>
<style lang="scss">
#tree-tabulator.tabulator {
  .tabulator-header{
    border-color: #aaa;
    .tabulator-headers{
      border-left: 1px solid #aaa;
      border-right: 1px solid #aaa;
      .tabulator-col{
        border-right-width: 1px;
        background-color: #214181 !important;
      }
    }
  }

  .tabulator-row {
    border-left-width: 1px;
    // border-right-width: 1px;
    border-color: #aaa;
    &.tabulator-row-odd{
      background: #f8f8f8;
    }
    .tabulator-cell{
      border-right-width: 1px;
      .tabulator-data-tree-control{
        background: rgb(33 65 129 / 85%);
        border: 1px solid rgb(33 65 129 / 85%);
        height: 13px;
        width: 13px;
        .tabulator-data-tree-control-expand{
          background: #FFF;
          border-left: 0;
          border-bottom: 0;
          &:after{
            background: #FFF;
          }
        }
        .tabulator-data-tree-control-collapse{
          &:after{
            background: #FFF;
          }
        }
      }
      .tabulator-data-tree-branch{
        border-left: 0;
        border-bottom: 0;
      }
    }
    &.tabulator-row-odd.tabulator-tree-level-1{
      background: #FFF;
      &:hover{
        background: #f5f6f8;
      }
    }
    &.tabulator-row-even.tabulator-tree-level-1{
      background: #FFF;
      &:hover{
        background: #f5f6f8;
      }
    }
  }
}
/*.tabulator .tabulator-row .tabulator-responsive-collapse{
  display: none;
}
// .tabulator .tabulator-header .tabulator-headers .tabulator-col, .tabulator .tabulator-row .tabulator-cell{
//   display: inline-block !important;
//   min-width: 80px;
//   width: 200px;
// }
.tabulator .tabulator-row .tabulator-responsive-collapse td strong {
  font-weight: 600 !important;
}
.tabulator-cell[tabulator-field=full_name]{
  font-weight: 600;
}
.tabulator-tree-level-1 .tabulator-responsive-collapse table {
    margin-left: 9px;
}
@media only screen and (max-width:1005px){
  .tabulator {
    .tabulator-tableHolder {
      // overflow: unset !important;
      .tabulator-table{
        white-space: normal !important;
        width: 100%;
        .tabulator-row .tabulator-responsive-collapse{
          display: block;
        }
      }
    }
  }
}*/


</style>
